import { render } from "./Error404View.vue?vue&type=template&id=3228a2c6&ts=true"
import script from "./Error404View.vue?vue&type=script&lang=ts"
export * from "./Error404View.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__